function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".cls-1{fill:#6cae3e;}.cls-2{fill:#232f3e;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "Virtual-private-cloud-VPC_dark-bg");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Working"
}, React.createElement("rect", {
  className: "cls-1",
  width: 35,
  height: 35
}), React.createElement("path", {
  className: "cls-2",
  d: "M19.85,17.69h-.74V17a2.15,2.15,0,0,0-4.29,0v.67h-.74a.5.5,0,0,0-.5.5V22a.5.5,0,0,0,.5.5h5.77a.5.5,0,0,0,.5-.5V18.19A.5.5,0,0,0,19.85,17.69Zm-4-.67a1.15,1.15,0,0,1,2.29,0v.67H15.82Zm3.53,4.43H14.58V18.69h4.77Z"
}), React.createElement("path", {
  className: "cls-2",
  d: "M26.42,16.09A3.67,3.67,0,0,0,24,12.77a3,3,0,0,0-2.76.58A7.86,7.86,0,0,0,19.63,11,6.79,6.79,0,0,0,12,9.5a7.12,7.12,0,0,0-4.06,6.29c0,.15,0,.29,0,.43A4.73,4.73,0,0,0,4.5,21c0,.13,0,.27,0,.4a5.07,5.07,0,0,0,5.11,4.66l16.25,0S30.5,25.66,30.5,21A4.9,4.9,0,0,0,26.42,16.09Zm-.59,9-16.21,0a4.06,4.06,0,0,1-4.11-3.73c0-.11,0-.22,0-.33a3.8,3.8,0,0,1,3.06-3.94.51.51,0,0,0,.37-.55,5.85,5.85,0,0,1,0-.73,6.17,6.17,0,0,1,3.45-5.37,6.09,6.09,0,0,1,2.4-.52,6,6,0,0,1,4.18,1.83,7.06,7.06,0,0,1,1.64,2.69.5.5,0,0,0,.87.13,2.08,2.08,0,0,1,2.26-.82,2.81,2.81,0,0,1,1.76,2.7.49.49,0,0,0,.4.56,4.07,4.07,0,0,1,0,8.1Z"
}));

var SvgAwsVpc = function SvgAwsVpc(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    className: "svgCloudServices",
    viewBox: "0 0 35 35",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAwsVpc, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/AWS-VPC.09e25d0b.svg";
export { ForwardRef as ReactComponent };